$(document).ready(function() {
    // Select all <li> elements within the unordered list with class "navigation__tier-1"
    $('ul.navigation__tier-1 li').each(function(index) {
        // Add an ID to each <li> element with a unique suffix based on its index
        $(this).attr('id', 'navigation__tier-1-item-' + (index + 1));
    });

 $('.april-link').click(function(e) {
                e.preventDefault();
                
                // Slide toggle with callback
                $('.hidden-content').slideToggle(400, function() {
                    // Toggle "active" class based on visibility
                    if ($(this).is(':visible')) {
                        $('.april-link').addClass('active')
                                       .text('X');
                    } else {
                        $('.april-link').removeClass('active')
                                       .text('-');
                    }
                });
            });


  
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".product-column-right .input-row").forEach(row => {
    const segmentBar = row.querySelector(".segment-bar");

    // only run logic if this row actually has a segment bar
    if (!segmentBar) return;

    const hasFilled = segmentBar.querySelector(".segment-bar__segment--filled");

    if (!hasFilled) {
      row.classList.add("hide-row");
    }
  });
});
			

